<template>
    <div class="layout-container table-special">
        <div style="background: #ffffff;position:relative;">
            <div class="search-condition-con" :class="'show'">
                <div class="search-condition">
                    <span class="label">话题名称</span>
                    <div class="input-condition">
                        <el-input v-model="condition.topic_name" placeholder="可输入话题关键词"></el-input>
                    </div>
                </div>
                <div class="search-condition">
                    <span class="label">问题规则</span>
                    <div class="input-condition">
                        <el-input v-model="condition.ask_name" placeholder="可输入问题关键词"></el-input>
                    </div>
                </div>
                <div class="search-condition">
                    <span class="label">回答规则</span>
                    <div class="input-condition">
                        <el-input v-model="condition.answer_name" placeholder="可输入回答关键词"></el-input>
                    </div>
                </div>
                <div class="">
                    <el-button type="primary" @click="handleSearch()">查 询</el-button>
                    <el-button  @click="resetSearch()">清空条件</el-button>
                </div>

            </div>
            <div class="btn-condition">
                <el-button
                type="primary"
                @click="handleAdd()"
                v-permission="'operating.house-topic.house-topic-model-ask.create'"
                >新增问答规则</el-button>
            </div>
        </div>
        <el-table
            :data="list"
            style="width: 100%"
            :highlight-current-row="true"
            :border="true"
            tooltip-effect="dark"
            ref="multipleTable"
            v-loading="isLoading"
            header-cell-class-name="table-back"
            class="list-table"
            >
                <el-table-column  label="话题名称" prop="topic_name" align="center"></el-table-column>
                <el-table-column  label="问题规则" prop="ask_name" align="center"></el-table-column>
                <el-table-column  label="回答规则" prop="answer_name" align="left">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top" width="500">
                            <p v-for="item,index in scope.row.answer_name" :key="index">{{scope.row.answer_name.length>1 ?`回答${index+1}: `+item:item }}</p>
                            <div slot="reference" class="name-wrapper">
                                <p class="ellipse4">
                                    <span style="display:block;" v-for="item,index in scope.row.answer_name" :key="index">{{scope.row.answer_name.length>1 ?`回答${index+1}: `+item:item }}</span>
                                </p>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column  label="更新人" prop="operator" align="center"></el-table-column>
                <el-table-column  label="更新时间" prop="updated_at"  align="center"></el-table-column>
                <el-table-column label="操作" width="300px" align="center">
                    <template slot-scope="scope">
                        <el-button  type="text" size="mini" @click="openEdit(scope.row)" v-permission="'operating.house-topic.house-topic-model-ask.edit'"
                            >编辑</el-button>
                        <el-button  type="text" size="mini" @click="handleDelet(scope.row.id)" v-permission="'operating.house-topic.house-topic-model-ask.delete'"
                            >删除</el-button>
                    </template>
                </el-table-column>
        </el-table>
        <template v-if="list.length > 0">
            <el-pagination
                background
                layout="total,prev, pager, next"
                :current-page="condition.page"
                :total="condition.total"
                :page-size="condition.per_page"
                @current-change="currentChange"
            ></el-pagination>
        </template>
        <add-rules ref="rulesAddRef" :callback="initData" />
        <edit-rules ref="rulesEditRef" :callback="initData" :asksInfo="asksInfo"/>
    </div>
</template>
<style>
    td a:link{
        color: #606266;
    }
    td a:visited{
        color: #606266;
    }
</style>
<script>
    import {singleAsksList,deleteSingleAsks} from '@/service/topicBank'
    import addRules from './addRules'; 
    import editRules from './editRules'; 
    export default {
        name: "List",
        components:{
            addRules,
            editRules
        },
        data () {
            return {
                list:[],
                condition:{
                    ask_name: '',
                    topic_name: '',
                    answer_name: '',
                    total: 0,
                    per_page:10,
                    page:1,
                },
                isLoading:false,
                asksInfo:{}
            }
        },
        mounted () {
            this.initData();
        },
        methods: {
            async initData(){
                this.isLoading = true;
                singleAsksList(this.condition).then(res => {
                    this.condition.total=res.total
                    this.list = res.data
                })
                this.isLoading = false;
            },
            currentChange(index) {
                this.condition.page = index;
                this.initData();
            },
            handleSearch(){
                this.initData()
            },
            resetSearch(){
                this.condition={
                    ask_name: '',
                    topic_name: '',
                    answer_name: '',
                    total: 0,
                    per_page:10,
                    page:1,
                }
                this.initData();
            },
            handleAdd(){
                this.$refs.rulesAddRef && 
                this.$refs.rulesAddRef.openMenu()
            },
            openEdit(row){
                this.asksInfo = JSON.parse(JSON.stringify(row))
                this.$refs.rulesEditRef && 
                this.$refs.rulesEditRef.openMenu()
            },
            handleDelet(id){
                this.$confirm("是否确认删除此问答规则，删除后不可恢复", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    deleteSingleAsks(id)
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "删除成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "删除失败"
                        });
                    });
                });
            }
        }
    }
</script>

<style scoped>
.ellipse4 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
}
</style>



















